export default class Dashboard {
  constructor(api) {
    this.api = api;
  }

  getData(reportUUID, filters, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/reports/" + reportUUID + "/data" + filters)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/dashboard.js